import { CallbackObject } from 'api/core/get-page-function';
import { plainToClass } from 'class-transformer';
import { GetDeviceVm } from './get-device.vm';
import { AxiosResponse } from 'axios';
import { instance } from 'api/core';

export const getDevice = async (deviceId: string, callback: CallbackObject<GetDeviceVm>) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };

  try {
    const res: AxiosResponse = await instance.get(`/management/devices/${deviceId}`, config);
    callback.success(plainToClass(GetDeviceVm, res.data));
  } catch (err) {
    if (callback.error) callback.error(err);
  }
};
